import script from "./OpenAccountForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./OpenAccountForm.vue?vue&type=script&setup=true&lang=ts"

import "./OpenAccountForm.vue?vue&type=style&index=0&id=c3731b9c&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c3731b9c"]])

export default __exports__